module.exports = __webpack_public_path__ + "assets/certificate_pdf/OCPJP6_Oracle Certified Professional, Java SE 6 Programmer_219907858OCPJSE6P.66b3c6d4.pdf";